module.exports = __webpack_public_path__ + "img/icon-address.c3df5dd6.svg";